import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '../contexts/AuthContext';

// Páginas
import Home from '../pages/Home';
import Login from '../pages/Login';
import Register from '../pages/Register';

// Módulo: Calendario
import CalendarioPage from '../pages/CalendarioPage';
import CitasPage from '../pages/CitasPage';
import LecturasPage from '../pages/LecturasPage';
import EventosPage from '../pages/EventosPage';

// Módulo: Posts
import Estudios from '../pages/Estudios'; // Página funcional
import PostDetail from '../pages/PostDetail';
import PostCrearPage from '../pages/PostCrearPage';
import CategoriasPage from '../pages/CategoriasPage';

// Páginas informativas para el Home
import BibliaInfo from '../pages/Info/BibliaInfo';
import PostsInfo from '../pages/Info/PostsInfo';
import MandamientosInfo from '../pages/Info/MandamientosInfo';
import CalendarioInfo from '../pages/Info/CalendarioInfo';
import HistoricidadInfo from '../pages/Info/HistoricidadInfo';

// Módulo: Historicidad
import HistoricidadPage from '../pages/HistoricidadPage';
import HistoricidadDetail from '../pages/HistoricidadDetail';
import HistoricidadCrearPage from '../pages/HistoricidadCrearPage';
import MisDatosHistoricos from '../pages/MisDatosHistoricos';

// Módulo: Biblia
import BibliaEstudio from '../pages/BibliaEstudio'; // Página funcional

// Módulo: Mitzvot (Mandamientos)
import ComparativaMandamientos from '../pages/ComparativaMandamientos'; // Página funcional
import MitzvotDetailImproved from '../components/Mitzvot/MitzvotDetailImproved'; // Detalle de mandamiento

// Contacto
import Contacto from '../pages/Contacto';

// Preguntas Frecuentes
import PreguntasFrecuentes from '../pages/PreguntasFrecuentes';

// Módulo: Administración
import UserManagement from '../pages/UserManagement';
import UserPermissions from '../pages/UserPermissions';
import AdminPanel from '../pages/AdminPanel';
import GestionCategorias from '../pages/GestionCategorias';
import ConfiguracionFlujo from '../pages/ConfiguracionFlujo';
import FormularioPost from '../pages/FormularioPost';
import FormularioDato from '../pages/FormularioDato';
import BandejaGestor from '../pages/BandejaGestor';
import BandejaValidador from '../pages/BandejaValidador';
import BandejaEditor from '../pages/BandejaEditor';
import RevisarDato from '../pages/RevisarDato';

// Layout
import MainLayout from '../components/Layout/MainLayout';

/**
 * Componente de rutas principal
 * Define todas las rutas de la aplicación
 */
export default function AppRoutes() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Rutas sin layout (Login/Register) */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* Rutas con MainLayout */}
          <Route path="/" element={<MainLayout><Home /></MainLayout>} />

          {/* Módulo: Calendario Hebreo */}
          <Route path="/calendario" element={<MainLayout><CalendarioPage /></MainLayout>} />
          <Route path="/citas" element={<MainLayout><CitasPage /></MainLayout>} />
          <Route path="/lecturas" element={<MainLayout><LecturasPage /></MainLayout>} />
          <Route path="/eventos" element={<MainLayout><EventosPage /></MainLayout>} />

          {/* Módulo: Estudio Bíblico */}
          <Route path="/biblia-estudio" element={<MainLayout><BibliaEstudio /></MainLayout>} />
          
          {/* Módulo: Posts y Categorías (Estudios) - Página funcional */}
          <Route path="/estudios" element={<MainLayout><Estudios /></MainLayout>} />
          <Route path="/estudios/:slug" element={<MainLayout><PostDetail /></MainLayout>} />
          <Route path="/posts" element={<MainLayout><Estudios /></MainLayout>} />
          <Route path="/posts/crear" element={<MainLayout><PostCrearPage /></MainLayout>} />
          <Route path="/posts/editar/:id" element={<MainLayout><PostCrearPage /></MainLayout>} />
          <Route path="/posts/:slug" element={<MainLayout><PostDetail /></MainLayout>} />
          <Route path="/categorias" element={<MainLayout><CategoriasPage /></MainLayout>} />

          {/* Páginas informativas para el Home */}
          <Route path="/info/calendario" element={<MainLayout><CalendarioInfo /></MainLayout>} />
          <Route path="/info/biblia" element={<MainLayout><BibliaInfo /></MainLayout>} />
          <Route path="/info/posts" element={<MainLayout><PostsInfo /></MainLayout>} />
          <Route path="/info/mandamientos" element={<MainLayout><MandamientosInfo /></MainLayout>} />
          <Route path="/info/historicidad" element={<MainLayout><HistoricidadInfo /></MainLayout>} />

          {/* Módulo: Mandamientos (Mitzvot) */}
          <Route path="/mandamientos" element={<MainLayout><ComparativaMandamientos /></MainLayout>} />
          <Route path="/mandamientos/:id" element={<MainLayout><MitzvotDetailImproved /></MainLayout>} />

          {/* Módulo: Historicidad */}
          <Route path="/historicidad" element={<MainLayout><HistoricidadPage /></MainLayout>} />
          <Route path="/historicidad/mis-datos" element={<MainLayout><MisDatosHistoricos /></MainLayout>} />
          <Route path="/historicidad/crear" element={<MainLayout><HistoricidadCrearPage /></MainLayout>} />
          <Route path="/historicidad/editar/:id" element={<MainLayout><HistoricidadCrearPage /></MainLayout>} />
          <Route path="/historicidad/:slug" element={<MainLayout><HistoricidadDetail /></MainLayout>} />

          {/* Contacto */}
          <Route path="/contacto" element={<MainLayout><Contacto /></MainLayout>} />

          {/* Preguntas Frecuentes */}
          <Route path="/faq" element={<MainLayout><PreguntasFrecuentes /></MainLayout>} />

          {/* Módulo: Administración (Solo Administradores) */}
          <Route path="/admin" element={<MainLayout><AdminPanel /></MainLayout>} />
          <Route path="/admin/users" element={<MainLayout><UserManagement /></MainLayout>} />
          <Route path="/admin/users/:userId/permissions" element={<MainLayout><UserPermissions /></MainLayout>} />
          
          {/* Panel de Administración (Posts) */}
          <Route path="/admin/posts" element={<MainLayout><AdminPanel /></MainLayout>} />
          <Route path="/admin/posts/nuevo" element={<MainLayout><FormularioPost /></MainLayout>} />
          <Route path="/admin/posts/editar/:id" element={<MainLayout><FormularioPost /></MainLayout>} />
          
          {/* Configuración del Flujo (Admin) */}
          <Route path="/admin/flujo/configuracion" element={<MainLayout><ConfiguracionFlujo /></MainLayout>} />
          
          {/* Gestión de Categorías (Admin) */}
          <Route path="/admin/categorias" element={<MainLayout><GestionCategorias /></MainLayout>} />
          
          {/* Bandejas de Workflow (Historicidad) */}
          <Route path="/historicidad/gestor" element={<MainLayout><BandejaGestor /></MainLayout>} />
          <Route path="/historicidad/gestor/nuevo" element={<MainLayout><FormularioDato /></MainLayout>} />
          <Route path="/historicidad/gestor/editar/:id" element={<MainLayout><FormularioDato /></MainLayout>} />
          <Route path="/historicidad/gestor/revisar/:id" element={<MainLayout><RevisarDato /></MainLayout>} />
          
          <Route path="/historicidad/validador" element={<MainLayout><BandejaValidador /></MainLayout>} />
          <Route path="/historicidad/validador/editar/:id" element={<MainLayout><FormularioDato /></MainLayout>} />
          <Route path="/historicidad/validador/revisar/:id" element={<MainLayout><RevisarDato /></MainLayout>} />
          
          <Route path="/historicidad/editor" element={<MainLayout><BandejaEditor /></MainLayout>} />
          <Route path="/historicidad/editor/editar/:id" element={<MainLayout><FormularioDato /></MainLayout>} />
          <Route path="/historicidad/editor/revisar/:id" element={<MainLayout><RevisarDato /></MainLayout>} />

          {/* Ruta 404 */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
